<template>
  <div class="form-wrapper">
    <div class="about">
        <div class="about-title">
            <h2>
                Contact
                <span>何でもご相談・制作依頼承ります。<br class="sp">お気軽にお問い合わせください。</span>
            </h2>
        </div>
    </div>

    <img src="@/assets/img/post_bar.png" class="top-post-bar">

    <b-card-text>
        <b-form>
            <div v-show="card_form_content">
                <div>
                    <div class="vadidate">※全て必須項目です</div>
                    <div class="form-label">お名前</div>
                    <b-form-input v-model="form_data.name" placeholder="name"></b-form-input>
                    <div class="form-label">メールアドレス</div>
                    <b-form-input v-model="form_data.email" placeholder="email"></b-form-input>
                </div>
                <div class="form-label">お問い合わせ内容</div>
                <b-form-textarea v-model="form_data.content" placeholder="content"></b-form-textarea>
            </div>
            <div class="confirm">
                <div class="alert-text">お問い合わせ内容にお間違いがないか再度ご確認ください。</div>
                <div class="form-confirm">お名前: <span>{{ form_data.name }}</span></div>
                <div class="form-confirm">メールアドレス: <span>{{ form_data.email }}</span></div>
                <div class="form-confirm">お問い合わせ内容: <span>{{ form_data.content }}</span></div>
                <img src="@/assets/img/post_icon.png" class="post-icon">
            </div>
            <div id="spinner" v-show="spinner">
                <b-spinner variant="success" label="Spinning"></b-spinner>
            </div>
            <transition name="post-alert">
                <b-alert v-show="post_message" variant="success" show>内容が投稿されました</b-alert>
            </transition>
            <transition name="post-validataion">
                <b-alert v-show="post_validation" variant="danger" show>内容を全てご入力して下さい</b-alert>
            </transition>
            <b-button @click="submit_form">お問い合わせ</b-button>
        </b-form>
    </b-card-text>
    <img src="@/assets/img/post_bar.png" class="bottom-post-bar">
    
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'form-wrapper',
    data() {
        return {
            form_data: {
                name: '',
                email: '',
                content: '',
            },
            id_last: '0',
            post_message: false,
            post_validation: false,
            spinner: false,
            card_form_content: true,
        }
    },
    created: function() {
        firebase.firestore().collection('posts_table').get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc){
                if(Number(doc.data().id) > Number(this.id_last)) {
                    this.id_last = doc.data().id
                }
            }.bind(this))
        }.bind(this))
    },
    methods: {
        submit_form: function() {
            if (this.form_data.name == '' || this.form_data.email == '' || this.form_data.content == '') {
                this.post_validation = true
                setTimeout(function(){
                    this.post_validation = false
                }.bind(this), 3000)
                return
            }

            this.id_last = String(Number(this.id_last) + 1)

            firebase.firestore().collection('posts_table').add({
                id: this.id_last,
                name: this.form_data.name.trim(),
                email: this.form_data.email.trim(),
                content: this.form_data.content.trim()
            })

            this.form_data.name = ''
            this.form_data.email = ''
            this.form_data.content = ''

            this.card_form_content = false
            this.spinner = true
            setTimeout(function(){ this.card_form_content = true }.bind(this), 700)
            setTimeout(function(){ this.spinner = false }.bind(this), 700)

            this.post_message = true
            setTimeout(function(){ this.post_message = false }.bind(this), 2000)
        }
    }
}
</script>

<style scoped>
    .sp {
        display: none;
    }
    .vadidate {
        text-align: center;
        font-size: 14px;
        color: rgb(255, 0, 0);
        margin: 0 auto;
        padding: 0;
    }
    .form-wrapper {
        width: 50%;
        margin: 100px auto;
    }
    h2 span {
        margin: 0 0 30px 0;
        letter-spacing: -1px;
    }
    .about {
        text-align: center;
    }
    .about .about-title {
        margin: 0 0 25px 0;
    }
    .about .about-title span {
        display: block;
        font-size: 12px;
    }
    .top-post-bar {
        width: 100%;
        margin: 0 0 25px 0;
    }
    .bottom-post-bar {
        width: 100%;
        margin: 25px 0 0 0;
    }
    input,textarea {
        font-family: sans-serif;
        margin: 0 0 15px 0;
        position: relative;
        z-index: 1;
    }
    textarea {
        margin: 0 0 50px 0;
        height: 150px;
    }
    button {
        width: 100%;
        color: #fff;
        padding: 10px;
        border: 1px dashed #F2999A;
        background: #F2999A;
        transition: .5s;
    }
    button:hover {
        color: #F2999A;
        background: #fff;
    }
    .form-label {
        text-align: left;
        margin: 0 0 5px 0;
    }
    ::placeholder{
        color:#ccc
    }
    .confirm {
        margin: 50px 0;
        padding: 50px;
        background: #fff;
        filter: drop-shadow(0 0 2px rgba(0,0,0,.1));
    }
    .confirm .alert-text {
        font-size: 16px;
        color: #36839C;
        margin: 0 0 30px 0;
    }
    .confirm .form-confirm {
        text-align: left;
        margin: 0 0 15px 0;
        word-wrap: break-word;
    }
    .confirm .post-icon {
        display: block;
        width: 100px;
        margin: 0 0 0 auto;
    }
    .post-alert-enter-active, .post-alert-leave-active {
        transition: opacity 2s, transform 1.5s;
    }
    .post-alert-enter {
        opacity: 0;
        transform: translateY(-50px);
    }
    .post-alert-leave-to {
        opacity: 0;
        transform: translateY(200px);
    }
    .post-validataion-enter-active, .post-validataion-leave-active {
        transition: opacity 1s, transform 1s;
    }
    .post-validataion-enter, .post-validataion-leave-to {
        opacity: 0;
        transform: translateY(-50px);
    }
    @media screen and (max-width:768px) {
        .sp {
            display: block;
        }
        .form-wrapper {
            width: 85%;
            margin: 0 auto 50px;
        }
        .confirm .form-confirm span {
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Form.vue